import { FeatureFlags } from 'application/constants/env-variables.ts';
import {
  OperationType,
  ProjectResourceType,
} from 'services/api/api-client.types.ts';

export type PermissionRequirement = {
  resource: ProjectResourceType;
  operations: OperationType[];
};

export type ProjectPermissionProps = {
  permissions: PermissionRequirement[];

  // TODO: Remove this property once the feature flag is removed from the codebase.
  // This property is used to override the feature flag for very specific cases.
  ignoreFeatureFlag?: ReturnType<
    (typeof FeatureFlags)['projectPermissionsEnabled']
  >;
};

export const permission = (
  resource: ProjectResourceType,
  ...operations: OperationType[]
) => ({
  resource,
  operations,
});
